"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useWindowEvent = require("./useWindowEvent");
Object.keys(_useWindowEvent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useWindowEvent[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useWindowEvent[key];
    }
  });
});